/**
 * Hardcoded feature gate for the Strategy Vaults product.
 * Flip to `true` to re-enable Strategy Vaults (UI, routes, and data-layer syncs).
 * Scope: Strategy Vaults ONLY — Insurance Fund Vaults and Market Making Vaults are unaffected.
 *
 * This file intentionally has no imports so it is safe to import from server route
 * handlers, client components, navigation config, and hooks without circular-dependency
 * or client/server bundling issues.
 */
export const ENABLE_STRATEGY_VAULTS = false;
